import type { LiveItem } from '@module/apis/client-side/live/type';

export function filterDuplicatesByUserIdx(items: LiveItem[]): LiveItem[] {
  const uniqueItems = new Map<number, LiveItem>();
  items.forEach((item) => {
    if (!uniqueItems.has(item.userIdx)) {
      uniqueItems.set(item.userIdx, item);
    }
  });
  return Array.from(uniqueItems.values());
}
